import { Component, OnInit, ViewChild, Input, SimpleChanges, OnChanges } from '@angular/core';
import { FacturedetailService } from 'src/app/service/facture.detail.service';
import { Facturedetail } from 'src/app/entity/Facture';
import { Table } from 'primeng/table';
import { ComposeMailComponent } from '../../email/include/compose-mail/compose-mail.component';
import { Contact } from 'src/app/entity/Contact';
import { Modelcores } from 'src/app/entity/Pjoint';
declare var jsPDF: any;
@Component({
  selector: 'app-materiel',
  templateUrl: './materiel.component.html',
  styleUrls: ['./materiel.component.css']
})
export class MaterielComponent implements OnInit,OnChanges {
  produits: Facturedetail[];
  prosuisSum:string
  cols: any[];
  colsExport: any[];
  exportColumns: any[];
  uploadedFiles: any[];
  @Input() index:number;
  @ViewChild(ComposeMailComponent )
  private composeMailComponent: ComposeMailComponent;

  @ViewChild('dt' ) DataTableVar: Table;
  constructor(private factureDetailService: FacturedetailService) { }
 /* ngAfterViewChecked(){
    let sum=0;
    if(this.DataTableVar && this.DataTableVar.filteredValue)
    this.DataTableVar.filteredValue.forEach(element => {
      let a=0 
      if(element.quantite)
      a=element.quantite
      sum+=a;
 
});

    //console.log('this.DataTableVar', sum);
    this.prosuisSum=sum +" Produits";
    }*/
  ngOnInit() {
  

    this.cols = [
      { field: 'designation', header: 'Désignation' },
      { field: 'quantite', header: 'Quantité' }, 
      { field: 'stand', header: 'Stands' }, 
      { field: 'numeroFiche', header: 'Facture' }, 
      { field: 'raisonSocial', header: 'Client' }, 
 
 
      
  ];
  
  this.colsExport = [
    { field: 'designation', header: 'Désignation' },
    { field: 'quantite', header: 'Quantité' }, 
    { field: 'stand', header: 'Stands' }, 
 
    { field: 'raisonSocial', header: 'Client' }, 


    
];


/*
 <td>{{produit.idfacture.client.raisonSocial}}  </td>
            <td>{{produit.designation}}</td>
            <td>{{produit.prixunit}}</td>

            <td>{{produit.quantite}}</td>

            <td>{{produit.idfacture.numeroFiche}}</td>
             
            <td>{{produit.idfacture.client.standList}}  </td>
    
*/
    this.exportColumns = this.colsExport.map(col => ({title: col.header, dataKey: col.field }));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.index==0 && !this.produits){
      this.factureDetailService.findMaterielSpeci().subscribe(result=>{
        this.produits=result;
      
     
         }
           
         );
    }
 
  }
  exportPdf() {
    this.uploadedFiles = []

    const doc = new jsPDF ( );
    doc.filename="cwxc";
    if(this.DataTableVar.filteredValue)
    doc.autoTable(
     
        
      
        this.exportColumns, this.DataTableVar.filteredValue,  {
            
 
            margin: {horizontal: 7},
           
            columnStyles: {0: {columnWidth: 100},1: {columnWidth: 15}}
        });
else    doc.autoTable(
   this.exportColumns, this.produits,  {
      

      margin: {horizontal: 7},
     
      columnStyles: {0: {columnWidth: 100},1: {columnWidth: 15}}
  });

  doc.save('materiel.pdf');
/*
var blobPdf= new Blob([doc.output('blob')],{type:'application/pdf'});
var blobUrl= URL.createObjectURL(blobPdf)

 
  
 blobPdf=   new Blob([doc.output('blob')], { type: 'application/pdf'  });


    this.uploadedFiles.push(blobPdf);
          this.composeMailComponent.prepareEmailModel(new Modelcores(),new Contact(), '', null, this.uploadedFiles)
 */
 
  }
  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.getCars());
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "primengTable");
    });
}
saveAsExcelFile(buffer: any, fileName: string): void {
  import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
          type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  });
}
getCars() {
  let cars = [];
  for(let car of this.produits) {
    let car1 = new Materiel();
    car1.Client = car.idfacture.client.raisonSocial.toString();
    car1.Designation=car.designation;
    car1.Quantite=car.quantite;
    car1.Stand=car.idfacture.client.standList;
         cars.push(car1);
     }
     return cars;
   }
   }
     class Materiel {
    Client:string;
     Designation: string;
    
     Quantite: number;
     Stand: string;
    
    
   
   }